import { render, staticRenderFns } from "./bo-lucene-search.vue?vue&type=template&id=7544c4a3"
import script from "./bo-lucene-search.vue?vue&type=script&lang=js"
export * from "./bo-lucene-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports